<ng-container>
    <div mat-dialog-title class="flex justify-between items-center min-w-[500px]">
        <div class="m-0 mr-1 text-xl">
            {{ title }}
        </div>
        <button mat-icon-button mat-dialog-close class="mat-elevation-z0 tx-close-button">
            <fa-icon icon="times" class="large-icon"></fa-icon>
        </button>
    </div>
    <div mat-dialog-content>
        <div class="flex flex-column">
            <mat-form-field appearance="fill">
                <mat-label>{{ 'txTeamConfig.name' | translate }}</mat-label>
                <input matInput #name>
            </mat-form-field>
            <mat-form-field>
                <mat-label>{{ 'txTeamConfig.teamleader' | translate }}</mat-label>
                <mat-select #select>
                    <mat-option *ngFor="let user of teamleaderUsers" [value]="user.persnr">
                        {{ user.lastname }}, {{ user.firstname }}
                    </mat-option>
                </mat-select>
            </mat-form-field>
            <div class="flex flex-justify-content-flex-end">
                <button
                        mat-raised-button
                        color="accent"
                        [mat-dialog-close]="{ teamleaderUser: select.value, name: name.value }"
                        [disabled]="!select.value || !name.value"
                >{{ 'txTeamConfig.create' | translate }}</button>
            </div>
        </div>
    </div>
</ng-container>
